export interface ISim {
    Id?: number;

    Iccid: string;
    Imsi: string;
    Msisdn: string;
    Status: SimStatus;
    Type: SimType;
    SimSubType?: SimSubType;
    LastUsageUpdate?: Date;
    LastDetailsUpdate?: Date;

}


export enum SimStatus {

    Active = 0,
    AwaitingCancellation = 1,
    Cancelled = 2,
    ActiveRoaming = 3,
    ActiveVoice = 4,
    Inactive = 5,
    Barred = 6,
    ActiveTest = 7,
    ActiveReady = 8,
    Unknown = 100
}

export enum SimType {

    Unknown = -1,
    WirelessLogic,
    Aeris,
    Isotrak,
    Arkessa,
    TM,
    Tele2
}

export enum SimSubType {

    Fusion

}




